import { BreadcrumbDataQuery } from '@lib/ui-components';
import {
  ReactQueryHateoasClientService,
} from '../libs/common-sdk/hateoas-rest-api-client/react-query-hateoas-client.service';

export const CommuneBreadcrumbProvider: BreadcrumbDataQuery = {
  fetchFunction(id: string): () => Promise<any> {
    return function () {
      return ReactQueryHateoasClientService.findOne<any>('communes', parseInt(id));
    };
  },

  mapToBreadcrumb(data: any): string {
    return data.name;
  },

  query: 'communes',
};
